// src/components/TranslatableText.jsx
import React, { useState, useEffect, useRef } from 'react';
import { useDictionary } from '../context/DictionaryContext';

const normalizeKey = (str) =>
  str.trim().toLowerCase().replace(/[.,!?;:()"""]/g, '');

export default function TranslatableText({ text }) {
  const dictionary = useDictionary();
  console.log('📖 dictionary keys:', Object.keys(dictionary).length, '| texto:', text?.slice(0, 30));
  const [tooltip, setTooltip] = useState(null);
  const [speaking, setSpeaking] = useState(false);

  // Cerrar al click fuera del tooltip
  useEffect(() => {
    const close = () => setTooltip(null);
    document.addEventListener('click', close);
    return () => document.removeEventListener('click', close);
  }, []);

  const handleWordClick = (e, token, entry) => {
    e.stopPropagation();
    const rect = e.target.getBoundingClientRect();
    setTooltip({
      word: token,
      translation: entry.translation,
      top: rect.bottom + 8,
      left: Math.min(rect.left, window.innerWidth - 290),
    });
  };

  const speak = () => {
    if (!tooltip || !window.speechSynthesis) return;
    window.speechSynthesis.cancel();
    const u = new SpeechSynthesisUtterance(tooltip.word);
    u.lang = 'en-US';
    u.onstart = () => setSpeaking(true);
    u.onend = () => setSpeaking(false);
    u.onerror = () => setSpeaking(false);
    window.speechSynthesis.speak(u);
  };

  // Partir el texto en tokens individuales (palabras + espacios + puntuación)
  const tokens = text.split(/(\s+)/);

  return (
    <>
      <span>
        {tokens.map((token, i) => {
          const key = normalizeKey(token);
          const entry = dictionary[key];

          if (entry) {
            return (
              <span
                key={i}
                onClick={(e) => handleWordClick(e, token, entry)}
                style={{
                  borderBottom: '2px dotted #f59e0b',
                  cursor: 'pointer',
                  borderRadius: 2,
                }}
              >
                {token}
              </span>
            );
          }
          return <span key={i}>{token}</span>;
        })}
      </span>

      {tooltip && (
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            position: 'fixed',
            top: tooltip.top,
            left: tooltip.left,
            zIndex: 99999,
            background: 'white',
            border: '1.5px solid #f59e0b',
            borderRadius: 12,
            padding: '10px 14px',
            boxShadow: '0 8px 24px rgba(0,0,0,0.18)',
            minWidth: 200,
            maxWidth: 280,
            fontSize: 14,
          }}
        >
          <div style={{ fontWeight: 700, color: '#1e293b', marginBottom: 4 }}>
            {tooltip.word}
          </div>
          <div style={{ color: '#475569', marginBottom: 10 }}>
            {tooltip.translation}
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button
              onClick={speak}
              style={{
                background: speaking ? '#0f766e' : '#f59e0b',
                color: 'white', border: 'none', borderRadius: 8,
                padding: '5px 12px', cursor: 'pointer',
                fontWeight: 700, fontSize: 13,
              }}
            >
              {speaking ? '🔊 ...' : '🔊 Audio'}
            </button>
            <button
              onClick={() => setTooltip(null)}
              style={{
                background: '#f1f5f9', color: '#64748b',
                border: 'none', borderRadius: 8,
                padding: '5px 12px', cursor: 'pointer',
                fontWeight: 700, fontSize: 13,
              }}
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </>
  );
}
